import { Component } from '@angular/core';

@Component({
    selector: 'catlish',
    template: require('./catlish.component.html'),
})

export class CatlishComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/catlish/catlish.component.ts
 **/